import { gql } from 'apollo-angular';

export var get_tax_credit_app_info = gql`
  query getTaxCreditAppInfo {
    taxCreditDesignations: taxCreditDesignations(active: true){
      id, name
    },
    taxCreditTypes: taxCreditTypes(active: true){
      id, name, level
    },
    HDAS: hdaOrgs(hasType: { column: NAME, operator: EQ, value: "HDA"} active: true){
      id,
      entity{
        id,
        organization{
          id, name
        }
      }
    },
  }
`;

export var find_funding_round_by_org_id = gql`
  query findFundingRoundByOrgID($organization_id: ID!) {
    findFundingRoundByOrgID: findFundingRoundByOrgID(organization_id: $organization_id){
      id, year, number, due_date, award_date
    }
  }
`;

export var create_app = gql`
  mutation createApp($input: addApplication!) {
    createApp: createApp(input: $input){
      id, amount_requested, request_date, awarded, project_id,
      taxCreditType{
        level, name
      },
      taxCreditDesignation{
        name
      },
      fundingRound{
        id, year, number, name, due_date, award_date,
        organization{
          id, name
        },
        state{
          name
        }
      },
      organization{
        id, name
      },
      person{
        id, name
      },
      project{
        id,
        projectStatuses{
          id, is_primary, active,
          status{
            id, name
          },
          statusSequence{
            id, name,
            status_sequence_details{
              index,
              status{
                id, name
              },
              milestoneStatus{
                id, pipeline_milestone_id, status_sequence_detail_id
              }
            }
          }
        },
        pipelineProjects{
          id, active,
          pipelineProjectDates{
            id, date, initial_target, target,
            pipelineMilestone{
              milestone{
                name
              },
              milestoneStatus{
                id, pipeline_milestone_id, status_sequence_detail_id
              }
            }
          },
          pipeline{
            name
          }
        },
      }
    }
  }
`;
